import React, {
  PureComponent,
  useCallback,
  useState,
  useEffect,
  useRef,
} from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

const options = {
  title: {
    text: "My chart",
  },
  series: [
    {
      data: [1, 2, 3],
    },
  ],
};

import "./HedonicScatter.css";

import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  LabelList,
  Label,
  CustomizedLabel,
  ReferenceArea,
} from "recharts";

export default function HedonicScatter({ data, metadata, cardSelected }) {
  function convertToScatter(data) {
    var newData = [];

    for (let i = 0; i < data.length; i++) {
      newData.push({
        Product: data[i].Label.Product,
        Hedonic_score: data[i].Point.Hedonic_score,
        Perception_score: data[i].Point.Perception_score,
      });
    }

    return newData;
  }

  var scatterPlotData = {
    labelled: convertToScatter(data[0].Labelled),
    notLabelled: convertToScatter(data[0]["Not-Labelled"]),
    selected: convertToScatter(data[0].Selected),
  };

  var dataSelected = data[0].Selected;
  var dataLabelled = data[0].Labelled;
  var dataNoLabelled = data[0]["Not-Labelled"];

  var allPoints = [];

  var selectedPoints = {
    name: `Candidats`,
    color: "#FEBE0A",
    data: [],
  };
  var selectPointsData = [];

  var labelledPoints = {
    name: `Moyenne ${metadata.Client}`,
    color: "#8884D8",
    data: [],
  };
  var labelledPointsData = [];

  var noLabelledPoints = { name: "Moyenne LLH", color: "#0D70B7", data: [] };
  var noLabelledPointsData = [];

  // SELECTED POINTS :
  for (let i = 0; i < dataSelected.length; i++) {
    var curData = dataSelected[i];
    var newObj = {};
    (newObj.name = curData.Label.Product.trim()),
      (newObj.x = curData.Point.Hedonic_score),
      (newObj.y = curData.Point.Perception_score),
      (newObj.color = "#FEBE0A");
    (newObj.showInLegend = false),
      (newObj.dataLabels = {
        align: "center",
        enabled: false,
        format: "{point.name}",
        borderColor: "",
        rotation: 0,
        states: {
          hover: {
            enabled: true,
          },
        },
        style: {
          fontSize: "9px",
          fontFamily: "Arial",
          zIndex: 999,
          position: "relative",
        },
      }),
      (newObj.borderColor = "#ffffff"),
      selectPointsData.push(newObj);
  }

  // LABELLED POINTS :

  for (let i = 0; i < dataLabelled.length; i++) {
    var curData = dataLabelled[i];
    var newObj = {};
    (newObj.name = curData.Label.Product.trim()),
      (newObj.x = curData.Point.Hedonic_score),
      (newObj.y = curData.Point.Perception_score),
      (newObj.color = "#8884D8");
    (newObj.showInLegend = false),
      (newObj.dataLabels = {
        align: "center",
        enabled: false,
        format: "{point.name}",
        borderColor: "",
        rotation: 0,
        states: {
          hover: {
            enabled: true,
          },
        },
        style: {
          fontSize: "9px",
          fontFamily: "Arial",
          zIndex: 999,
          position: "relative",
        },
      }),
      (newObj.borderColor = "#ffffff"),
      labelledPointsData.push(newObj);
  }

  //NO-LABELLED POINTS :

  for (let i = 0; i < dataNoLabelled.length; i++) {
    var curData = dataNoLabelled[i];
    var newObj = {};
    (newObj.x = curData.Point.Hedonic_score),
      (newObj.y = curData.Point.Perception_score),
      (newObj.color = "#0D70B7");
    newObj.showInLegend = false;
    noLabelledPointsData.push(newObj);
  }

  selectedPoints.data = selectPointsData;
  labelledPoints.data = labelledPointsData;
  noLabelledPoints.data = noLabelledPointsData;

  allPoints.push(selectedPoints);

  dataNoLabelled.length > 0 ? allPoints.push(noLabelledPoints) : "";
  dataLabelled.length > 0 ? allPoints.push(labelledPoints) : "";

  const options = {
    chart: {
      type: "scatter",
      zoomType: "xy",
    },
    title: {
      text: "",
    },
    xAxis: {
      title: {
        enabled: true,
        text: "Hedonic score",
      },
    },
    yAxis: {
      title: {
        text: "Perception score",
      },
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          format: "{point.name}",
          align: "center",
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
      point: {
        events: {
          mouseOver: function (e) {
            this.series.data.forEach((p) => {
              p.update(
                {
                  dataLabels: {
                    enabled: true,
                  },
                },
                false,
                false
              );
            });
            this.update({
              dataLabels: {
                enabled: true,
              },
              Tooltip: {
                enabled: false,
              },
            });
          },
        },
      },
    },
    navigation: {
      buttonOptions: {
        enabled: true,
      },
    },
    tooltip: {
      enabled: true,
      format: "{point.name}",
      formatter: function () {
        return `<div class="tooltip-scatter" style="align-text:'left';font-weight:'regular'"><b>${
          this.point.name != undefined
            ? "Product: " + this.point.name
            : "Product: n/a"
        }<br />
        Hedonic Score: ${this.x}<br/>
        Perception Score: ${this.y}</div>`;
      },
    },
    series: allPoints,
  };
  const chart = useRef();

  const downloadCSV = () => {
    if (chart && chart.current && chart.current.chart) {
      chart.current.chart.exportChart();
    }
  };

  return (
    <>
      <button onClick={downloadCSV} className="btn btn__scatter">
        <code>Download</code>
      </button>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chart}
        containerProps={{
          style: {
            height: "100%",
            width: "60%",
            display: "flex",
            justifyContent: "center",
          },
        }}
      />
    </>
  );
}
